import React from 'react';
import i18n from 'i18next';
import Link from 'next/link';

// Dropdown доторх дэд цэс: энгийн жижиг текст холбоос.
const MenuSubItem = ({
    menu,
    showsMenu = true,
    textStyle = '',
    style = '',
    onClick,
}) => {
    return (
        <li
            className={`${showsMenu ? 'block' : 'hidden'} ${style}`}
            onClick={onClick}
        >
            <Link
                // Урд нь '/'-тэй хадгалагдсан url-ийг нормчилж давхар '//' үүсгэхгүй.
                href={
                    menu.url
                        ? '/' + menu.url.replace(/^\/+/, '')
                        : '/content/' + menu.id
                }
                // Бүтээгдэхүүний хуудсан дээр байхад ангилал солих нь shallow (хуудас дахин ачаалахгүй).
                shallow={Boolean(
                    menu.url &&
                    menu.url.replace(/^\/+/, '').startsWith('products/'),
                )}
                className={`block py-1.5 text-[13px] text-ink hover:text-ink/70 transition-colors ${textStyle}`}
            >
                {menu.names?.find((item) => item.langCode === i18n.language)
                    ?.name ||
                    menu.names?.find((item) => item.langCode === 'mn')?.name}
            </Link>
        </li>
    );
};

export default MenuSubItem;
